import React from "react";
import styles from "./index.module.scss"
import clsx from "clsx"

export default ({ onClick, children, type, className }) => (
    <button
      onClick={onClick}
      className={clsx(
        styles.defaults,
        styles[type], 
        className)}
    >
      {children}
    </button>
)
